import { OAuthRedirect } from '../../OAuth/OAuthRedirect';
import { useUpdateOAuthState } from '../../OAuth/useUpdateOAuthState';

export const PaycorOauthCallback = () => {
  const { isLoading, postError } = useUpdateOAuthState();

  return <OAuthRedirect isLoading={isLoading} error={postError} />;
};
